import { useQuery } from '@tanstack/react-query';
import type { ResolvedProfile } from '@efacture/core/sector';
import { apiClient } from '@/api/client';

// Re-exported so callers do not need a second import from '@efacture/core'.
export type { ResolvedProfile };

/**
 * Resolved sector profile — GET /api/sector-profile/resolved
 * Server contract: packages/api/src/routes/sector-profile/index.ts,
 *                   packages/api/src/services/sector/sector-profile.service.ts
 *
 * The payload is tenant-scoped and NOT permission-filtered server-side: any
 * authenticated member of the tenant can read it, since it drives navigation
 * rather than authorization. `unrestricted` is the only signal for "no
 * profile restriction" — an empty `modules` list never implies that.
 */
export const sectorProfileKeys = {
  all: ['sector-profile'] as const,
  resolved: () => [...sectorProfileKeys.all, 'resolved'] as const,
};

export function useSectorProfile(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: sectorProfileKeys.resolved(),
    queryFn: () =>
      apiClient.get<{ profile: ResolvedProfile }>('/sector-profile/resolved'),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
